import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  templateUrl: './header.component.html',
  selector: 'main-header',
})
export class HeaderComponent {

}
